import * as store from './store.js';
import * as env from './env.js';
import { taskInterfaceFn } from '../interface/TaskInterface.js';
import { TASK_API_ERRORS } from './constants.js';

/**
 * Initialize the Tasks API service by detecting environment and setting up TaskServiceInterface.
 * Mirrors the notification setup pattern from notification-helpers.js
 */
export const setupTasks = () => {
	// Detect environment name using IDM gateway URL or passport domain
	let envName = 'prod';
	const passportData = store.get('passport-data');
	const passportCfg = store.get('passport');
	if (passportCfg === null) { return; }
	if (passportData !== null) {
		envName = env.environmentFromPassportDomain(window.location.hostname);
	}

	const envValues = env[envName] || env.prod;
	const taskSvcBaseUrl = envValues.taskSvcBaseUrl;

	// Guard: if endpoint not configured, log error and return
	if (!taskSvcBaseUrl) {
		console.error(TASK_API_ERRORS.ENDPOINT_REQUIRED);
		return;
	}

	// Initialize TaskServiceInterface
	taskInterfaceFn(store, taskSvcBaseUrl);
};
